module.exports = __webpack_public_path__ + "img/music.65b057d1.png";